// Kolom datetime master (mvyg*Time, mroh*Time, bklg*Datetime) disimpen & dibaca
// backend sebagai UTC+0, dikirim sebagai string naif tanpa penanda zona.
// Konversinya ikut zona browser — sengaja tidak dipatok WIB.
import moment from 'moment';

// Jam lokal dari <input type="datetime-local"> -> string UTC buat payload API.
export function toApiDatetime(local, format = 'YYYY-MM-DD HH:mm:ss') {
  return moment(local).utc().format(format);
}

// String UTC dari API -> moment lokal. Pemanggil yang nentuin format tampilannya.
export function fromApiDatetime(stored) {
  return moment.utc(stored).local();
}

// String UTC dari API -> epoch detik, buat endpoint /summary/* & /series/*.
export function apiDatetimeToUnix(stored) {
  return moment.utc(stored).unix();
}

// Offset zona browser dalam jam (WIB = 7), buat param `timezone` endpoint summary.
export function browserUtcOffsetHours() {
  return new Date().getTimezoneOffset() / -60;
}

// Format tampilan kanonik. Jangan tulis format sendiri di komponen — pakai ini,
// biar satu momen kelihatan sama di semua halaman.
// Chart, nama file, dan payload API TIDAK pakai ini: offset bikin nama file
// invalid dan label sumbu chart kepanjangan.
export const DISPLAY_DATE = 'DD MMMM YYYY';
export const DISPLAY_DATETIME = 'DD MMMM YYYY, HH:mm:ss Z';

// Chart punya preset sendiri: kanonik kepanjangan (31 karakter) buat tooltip,
// dan offset bikin label sumbu saling tabrakan.
export const CHART_TOOLTIP = 'DD MMM YYYY HH:mm';
export const CHART_AXIS = 'DD/MM/YY HH:mm';

// String UTC dari API -> teks tampilan kanonik.
export function formatApiDatetime(stored) {
  return stored ? fromApiDatetime(stored).format(DISPLAY_DATETIME) : '-';
}
